import { animate, group, query, style } from '@angular/animations';

export const left = [
  query(':enter, :leave', style({ display: 'block', width: '100%' }), {
    optional: true,
  }),
  group([
    query(
      ':enter',
      [
        style({ transform: 'translateX(-1000%)', position: 'absolute' }),
        animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
      ],
      {
        optional: true,
      },
    ),
    query(
      ':leave',
      [
        style({ transform: 'translateX(0%)' }),
        animate('.3s ease-out', style({ transform: 'translateX(1000%)' })),
      ],
      {
        optional: true,
      },
    ),
  ]),
];

export const right = [
  query(':enter, :leave', style({ display: 'block', width: '100%' }), {
    optional: true,
  }),
  group([
    query(
      ':enter',
      [
        style({ transform: 'translateX(1000%)', position: 'absolute' }),
        animate('.3s ease-out', style({ transform: 'translateX(0%)' })),
      ],
      {
        optional: true,
      },
    ),
    query(
      ':leave',
      [
        style({ transform: 'translateX(0%)' }),
        animate('.3s ease-out', style({ transform: 'translateX(-1000%)' })),
      ],
      {
        optional: true,
      },
    ),
  ]),
];
